const isEmpty = (array) => {
  return array.length <= 0
}

export default isEmpty
